export const SERA_PHONE =
  import.meta.env.VITE_SERA_PHONE ?? "+1 (516) 363-3139";
export const SERA_DEMO_URL = "https://calendly.com/sera-ai/demo";
export const SERA_APP_URL = "https://app.joinsera.us";
